import { Logo } from "@repo/ui/components/ui/logo"

import { config } from "../config"

export function AuthPanel() {
  return (
    <div className="bg-primary text-primary-foreground flex items-center justify-center gap-3.5">
      <Logo width={44} />
      <span className="text-3xl font-semibold">{config.appName}</span>
    </div>
  )
}
